import React from 'react'
import { Grid, Row, Col, Glyphicon } from 'react-bootstrap'
import { connect } from 'react-redux'
import { getSesamRequests, getSesamLockDescriptions } from '../redux/dataAnalyticsActions'

import SesamRequestsTable from './SesamRequestsTable'
import SesamAllThreadsTable from './SesamAllThreadsTable'
// import SesamLock from './SesamLock'

import SesamThreadModal from './SesamThreadModal'
import SesamViewLogModal from './SesamViewLogModal'

const requestButtons = [
    { name: 'lockedspaces' },
    { name: 'accessrequest' },
    { name: 'accesskey' },
    { name: 'accessevent' },
    { name: 'lockedspaceposition' },
    { name: 'revokeaccess' },
    { name: 'accessdeviation' }
]

const btn = { padding: 10, margin: 5, border: '1px solid black', float: 'left' }

const activeBtn = {
    ...btn,
    backgroundColor: "#006e78",
    color: 'white'
}

const inactiveBtn = {
    ...btn,
    backgroundColor: "white",
    color: 'black'
}

class Sesam extends React.Component {
    constructor(p) {
        super(p)

        this.state = { selectedRequestName: 'lockedspaces', fetching: false, threadId: null, threadLock: null, logId: null }
    }

    componentDidMount() {
        this.props.getSesamRequests()
        this.props.getSesamLockDescriptions()

    }

    renderDataView = () => {
        const sesamRequests = this.props.sesamRequests || []
        const filteredSesamRequests = sesamRequests.filter((request) => request.lambdaFn && request.lambdaFn.toLowerCase().includes(this.state.selectedRequestName))

        switch (this.state.selectedRequestName) {
            case "threads": return <SesamAllThreadsTable onThreadClick={(threadId, threadLock) => this.setState({ threadId, threadLock })} />

            default: return <SesamRequestsTable sesamRequests={filteredSesamRequests} requestName={this.state.selectedRequestName} onViewLogClick={(requestContext) => this.setState({ threadId: null, threadLock: null, requestContext })} onThreadClick={(threadId, threadLock) => this.setState({ threadId, threadLock })} />
        }
    }

    componentWillReceiveProps() {
        this.setState({ fetching: false })
    }

    render() {

        return (
            <Grid fluid>
                {this.state.threadId ? <SesamThreadModal threadId={this.state.threadId} lock={this.state.threadLock} closeModal={() => this.setState({ threadId: null, threadLock: null })} /> : null}
                {this.state.requestContext ? <SesamViewLogModal requestContext={this.state.requestContext} closeModal={() => this.setState({ requestContext: null }, () => console.log(this.state))} /> : null}

                {/* <Row>
                    <Col xs={12} md={12} lg={12} style={{ textAlign: 'center' }}>
                        <h1>Välkommen till Sesam</h1>
                        <Glyphicon style={{ fontSize: 40, cursor: 'pointer' }} glyph="glyphicon glyphicon-refresh" onClick={() => this.props.getSesamRequests()}></Glyphicon>
                    </Col>
                </Row> */}

                <Row>
                    <Col xs={12} md={12} lg={12} style={{ textAlign: 'center', backgroundColor: 'white' }}>
                        {requestButtons.map(btn => {
                            return (
                                <div className="hoverEffect" key={btn.name} style={this.state.selectedRequestName === btn.name ? activeBtn : inactiveBtn} onClick={() => this.setState({ selectedRequestName: btn.name })}>{btn.name}</div>
                            )
                        })}

                        <div className="hoverEffect" style={{ padding: 10, margin: 5, border: '1px solid black', float: 'left' }} onClick={(e) => { this.setState({ fetching: true }); this.props.getSesamRequests() }}>
                            {this.state.fetching === true ? 'Hämtar ...' : <Glyphicon glyph="glyphicon glyphicon-refresh"></Glyphicon>}
                        </div>


                        <div className="hoverEffect" style={{ padding: 10, margin: 5, border: '1px solid black', float: 'left', marginLeft: 100 }} onClick={(e) => this.setState({ selectedRequestName: 'threads' })}>
                            Trådar
                        </div>
                    </Col>
                </Row>

                <hr />

                <Row>
                    <Col xs={12} md={12} lg={12}>
                        {this.renderDataView()}
                    </Col>
                </Row>

                <hr />

                {/* <Row>
                    {locks.map((lock, i) => {
                        return (
                            <Col key={i} xs={4} md={4} lg={4} style={{ backgroundColor: 'white', marginLeft: 5 }}>
                                <SesamLock lock={lock} flows={sesamFlows.filter(r => r.lockId === lock._id)} />
                            </Col>
                        )
                    })}
                </Row> */}
            </Grid>
        )
    }
}


const mapProps = state => {
    return {
        sesamFlows: state.dataAnalytics.sesamFlows,
        sesamRequests: state.dataAnalytics.sesamRequests,
        locks: state.collectionData.locks
    }
}

const mapDispatch = dispatch => {
    return {
        getSesamRequests: (...args) => dispatch(getSesamRequests(...args)),
        getSesamLockDescriptions: (...args) => dispatch(getSesamLockDescriptions(...args))
    }
}

export default connect(mapProps, mapDispatch)(Sesam)